import React from 'react'

const style = {
    overlay: { 
        position: 'fixed',
        top: 0,
        zIndex: 1600,
        width: '100%',  
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.2)'
    },
    loader: {
        position: 'fixed',
        top: '50%',
        left: "calc(50% - 30px)",
        border: '4px solid #FFFFFF',
        borderRadius: '50%',
        borderTop: '4px solid #66d0cb',
        width: '60px',
        height: '60px',
        WebkitAnimation: 'spin 1s linear infinite',
        animation: 'spin 1s linear infinite'
    }
}

export default () => (
<div style={style.overlay}>
    <div className="loader" style={style.loader}></div>
</div>
)


// WEBPACK FOOTER //
// ./src/components/LoadingOverlay/index.js